export default __webpack_public_path__ + "static/media/inter-medium-webfont.6b7d8607.woff2";